/** Primary inbox for sales, support, contact, and form submissions. */
export const SITE_CONTACT_EMAIL = 'info@technoconix.com';

export const SITE_CONTACT_MAILTO = `mailto:${SITE_CONTACT_EMAIL}`;

export const SITE_BRAND_NAME = 'TechnoConix';
